var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNempri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 25.909,
    cy: 21.599,
    r: 1.218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.224 34.994c-2.251-.728-3.189-2.555-3.189-5.042V9.217a5.58 5.58 0 015.584-5.584h10.834M30.493 16.121v-5.39M23.456 3.736l6.992 6.991"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M22.588 4.948v6.62h6.991"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M22.911 24.108L16.2 30.819c-2.146 2.146-2.121 5.682-.409 7.393l.471.449c1.467 1.467 4.049 1.701 6.361.455.646-.348 1.21-.83 1.729-1.349l12.044-12.048c1.003-1.003.216-1.918.216-1.918l-2.247-2.164c-.495-.495-1.407-.392-2.027.228l-11.79 11.79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNempri);
export default __webpack_public_path__ + "static/media/NEMPRI.4c289a67d2092cab00b98c3dbf9e468b.svg";
export { ForwardRef as ReactComponent };